export function isFeedNearTop(threshold = 160) {
  if (typeof window === 'undefined') return true;
  return window.scrollY <= threshold;
}

function replySignature(replies, depth = 0) {
  if (!Array.isArray(replies) || depth > 5) return '';
  return replies
    .map((reply) => {
      const nested = reply.children || reply.replies || [];
      return `${reply.id}:${reply.content || ''}:${replySignature(nested, depth + 1)}`;
    })
    .join(',');
}

export function postFingerprint(post) {
  if (!post) return '';
  const replies = Array.isArray(post.replies) ? post.replies : [];
  const media = Array.isArray(post.media) ? post.media : [];
  return [
    post.id,
    post.content ?? '',
    post.title ?? '',
    post.updated_at ?? '',
    post.created_at ?? '',
    post.post_type ?? '',
    post.like_count ?? '',
    post.replyCount ?? replies.length,
    post.cover_image ?? '',
    media.map((item) => item.url || item).join(','),
    replySignature(replies),
  ].join('|');
}

/**
 * Patch posts already on screen and optionally prepend brand-new ones.
 * Does not drop older infinite-scroll items just because they fell off page 1.
 */
export function mergeFeedPosts(prev, incoming, options = {}) {
  const prependNew = options.prependNew === true;
  const removeMissing = options.removeMissing === true;
  const prevList = Array.isArray(prev) ? prev : [];
  const nextIncoming = Array.isArray(incoming) ? incoming : [];

  const incomingById = new Map(nextIncoming.map((post) => [String(post.id), post]));
  const prevIds = new Set(prevList.map((post) => String(post.id)));
  const brandNew = nextIncoming.filter((post) => !prevIds.has(String(post.id)));

  let changed = false;
  let updated = prevList.map((post) => {
    const newer = incomingById.get(String(post.id));
    if (!newer) return post;
    if (postFingerprint(post) === postFingerprint(newer)) return post;
    changed = true;
    return { ...post, ...newer };
  });

  if (removeMissing) {
    const incomingIds = new Set(nextIncoming.map((post) => String(post.id)));
    const kept = updated.filter((post) => incomingIds.has(String(post.id)));
    if (kept.length !== updated.length) {
      changed = true;
      updated = kept;
    }
  }

  if (brandNew.length && prependNew) {
    return {
      posts: [...brandNew, ...updated],
      heldNew: [],
      prepended: brandNew,
      changed: true,
    };
  }

  if (!changed && brandNew.length === 0) {
    return { posts: prevList, heldNew: [], prepended: [], changed: false };
  }

  return {
    posts: updated,
    heldNew: brandNew,
    prepended: [],
    changed,
  };
}
